// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__SXTn0","wrapper_left":"Header_wrapper_left__BgBJ6","wrapper_title":"Header_wrapper_title__C8fwi","wrapper_count":"Header_wrapper_count__vq0Xr"};